var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{staticClass:"pin-button",attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"small":"","color":_vm.pinned ? 'primary': ''}},on),[_vm._v(" "+_vm._s(_vm.pinned ? 'visibility': 'visibility_off')+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.pinned ? 'Unpin column' : 'Pin column'))])])}
var staticRenderFns = []

export { render, staticRenderFns }